/**
 * RESPONSIBILITY: the band at the top of every page.
 *
 * The whole navigation is one list. A new ministry page is a new row, not a code change
 * — which is the point of the dropdowns being data rather than markup.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Img, List } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';
import { NavLink } from './rows/nav-link';

@Section({ name: SectionName.Header, label: 'Header (every page)', always: true })
export class HeaderSection {
  @Text({
    label: 'Church short name', maxLength: 120, default: 'ACFI',
    description: 'Shown beside the logo, and on narrow screens instead of the full name.',
  })
  mark!: string;

  @Text({ label: 'Church full name', maxLength: 300, default: 'Austin Christian Fellowship of India' })
  fullName!: string;

  @Img({
    label: 'Logo', folder: 'brand', maxSizeMb: 12, size: '256 px tall or more',
    description:
      'Shown at the top of every page, beside the short name. Any shape — a tall crest '
      + 'or a wide wordmark both work. A transparent PNG sits best on the header.',
  })
  logo!: ImageValue;

  @List({
    label: 'Navigation', of: () => NavLink, maxItems: 40,
    description: 'The whole menu. A row with "Under" set becomes an item of that dropdown.',
  })
  nav!: NavLink[];
}
